import { SaiQuickTourFormCoachStep } from 'app/ui/sai-quick-tour/sai-quick-tour-form-coach.types';

/** Guided walkthrough inside Add Data Source while the main tour is on that step. */
export const SAI_QUICK_TOUR_DS_FORM_COACH_STEPS: readonly SaiQuickTourFormCoachStep[] = [
    {
        id: 'ds-intro',
        titleKey: 'Tour · Meet the Add Data Source form',
        bodyKey:
            'We prefilled a demo setup for you. Walk through each field to see why it matters — then save when you are ready.',
    },
    {
        id: 'ds-name',
        titleKey: 'Tour · Data Source Name',
        bodyKey:
            'A clear name helps everyone find this source later in agents, chat, and tracker. Demo value: “Demo Sales Data”.',
        fieldTourId: 'ds-field-name',
        sampleKey: 'Demo Sales Data',
    },
    {
        id: 'ds-department',
        titleKey: 'Tour · Department',
        bodyKey:
            'Link the source to a department from your hierarchy so the right teams can use it — and sharing stays controlled.',
        fieldTourId: 'ds-field-department',
    },
    {
        id: 'ds-owner',
        titleKey: 'Tour · Owned By',
        bodyKey:
            'The owner is accountable for this source — usually your Admin on first setup. Managers can own department sources later.',
        fieldTourId: 'ds-field-owner',
    },
    {
        id: 'ds-type',
        titleKey: 'Tour · Data Source Type',
        bodyKey:
            'Internal means you upload files here (CSV, XLSX, documents). External connects live systems like SAP or Snowflake.',
        fieldTourId: 'ds-field-type',
        sampleKey: 'Internal Data Source',
    },
    {
        id: 'ds-datatype',
        titleKey: 'Tour · Data Type',
        bodyKey:
            'Structured Tables fit spreadsheets, rows, and Hyper Forms submissions. Pick Documents for PDFs/text.',
        fieldTourId: 'ds-field-datatype',
        sampleKey: 'Structured Table',
    },
    {
        id: 'ds-save',
        titleKey: 'Tour · Save your data source',
        bodyKey:
            'Everything looks good. Click Add to create it — next you will upload a file into this source.',
        fieldTourId: 'ds-field-submit',
    },
];
